import api from './api';

const unwrap = async (promise) => (await promise).data;

export const getCommunicationBootstrap = () => unwrap(api.get('/communications/bootstrap'));
export const updateCommunicationTrigger = (key, payload) => unwrap(api.patch(`/communications/triggers/${encodeURIComponent(key)}`, payload));

export const listCommunicationProviders = () => unwrap(api.get('/communications/providers'));
export const saveCommunicationProvider = (payload) => payload?.id
  ? unwrap(api.put(`/communications/providers/${payload.id}`, payload))
  : unwrap(api.post('/communications/providers', payload));
export const deleteCommunicationProvider = (id) => unwrap(api.delete(`/communications/providers/${id}`));
export const getProviderStatus = (id) => unwrap(api.get(`/communications/providers/${id}/status`));
export const listNotifinoTemplates = () => unwrap(api.get('/communications/notifino/templates'));

export const listCommunicationTemplates = () => unwrap(api.get('/communications/templates'));
export const saveCommunicationTemplate = (payload) => payload?.id
  ? unwrap(api.put(`/communications/templates/${payload.id}`, payload))
  : unwrap(api.post('/communications/templates', payload));
export const deleteCommunicationTemplate = (id) => unwrap(api.delete(`/communications/templates/${id}`));
export const getCommunicationTemplateVariables = (triggerKey = '') => unwrap(api.get('/communications/template-variables', { params: { trigger_key: triggerKey } }));
export const previewCommunicationTemplate = (payload) => unwrap(api.post('/communications/templates/preview', payload));
export const testCommunicationTemplate = (payload) => unwrap(api.post('/communications/templates/test', payload));

export const listCommunicationRules = () => unwrap(api.get('/communications/rules'));
export const saveCommunicationRule = (payload) => payload?.id
  ? unwrap(api.put(`/communications/rules/${payload.id}`, payload))
  : unwrap(api.post('/communications/rules', payload));
export const deleteCommunicationRule = (id) => unwrap(api.delete(`/communications/rules/${id}`));

export const listCommunicationDeliveries = (params = {}) => unwrap(api.get('/communications/deliveries', { params }));
export const retryCommunicationDelivery = (id) => unwrap(api.post(`/communications/deliveries/${id}/retry`));
export const listCommunicationOutbox = () => unwrap(api.get('/communications/outbox'));
export const retryCommunicationOutbox = (id) => unwrap(api.post(`/communications/outbox/${id}/retry`));
export const processCommunicationOutbox = (limit = 30) => unwrap(api.post('/communications/outbox/process', { limit }));

export const listPaymentReminderPolicies = () => unwrap(api.get('/communications/payment-reminder-policies'));
export const savePaymentReminderPolicy = (payload) => payload?.id
  ? unwrap(api.put(`/communications/payment-reminder-policies/${payload.id}`, payload))
  : unwrap(api.post('/communications/payment-reminder-policies', payload));
export const deletePaymentReminderPolicy = (id) => unwrap(api.delete(`/communications/payment-reminder-policies/${id}`));
